import { render } from "./AssignDeliveriesToTeams.vue?vue&type=template&id=bacfe0d4"
import script from "./AssignDeliveriesToTeams.vue?vue&type=script&lang=js"
export * from "./AssignDeliveriesToTeams.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__